import { JwtPayload } from "jwt-decode";

export interface PrivateInfosClaim {
	Name?: string;
	Surname?: string;
	Address?: string;
	City?:string;
	Province?: string;
	Cap?: string;
	Nation?: string;
	Birthday?: Date;
	FiscalCode?: string;
}

export interface CompanyAssociationClaim {
	Name?: string;
	Address?: string;
	City?: string;
	Cap?: string;
	Nation?: string;
	Province?: string;
	Vat?: string;
	FiscalCode?: string;
	
}

export interface IUser extends JwtPayload{
	userId: string;
	username: string;
	email: string;
	isprivate: boolean;
	conventioned: boolean;
	userType: string;
	refCode: string;
	// Name?: string;
	// Surname?:string;
	association?:string;
	associationId?:string;
	enableduser?:boolean | string;
	'is-national-entity'?: boolean | string;
	approvedfromassociation?:number | string;
	approvedfromAdmin?:number | string;
	// address?:string;
	// province?:string;
	// cap?:string;
	// nation?:string;
	// birthday?:string;
	// fiscalcode?:string;
	privateInfo?: PrivateInfosClaim;
	companyAssociationInfo?: CompanyAssociationClaim;
	role:string[]
}

export enum EFidelityLevelMan {
	PIONEER = "PIONEER",
	LORD = "LORD",
	KING = "KING"
}


export enum EFidelityLevelWoman{
	PIONEER = "PIONEER",
	LADY = "LADY",
	QUEEN = "QUEEN",
}

export enum Gender {
	male = "male",
	female = "female"
}

export interface FidelityLevel {
	gender: Gender;
	level: EFidelityLevelMan | EFidelityLevelWoman;
}

export enum ESex {
	Male,
	Female
}